import { memo } from 'react';

import styles from './index.less';

interface IProps {
  content: string;
  avatar?: string;
  displayName?: string;
}

const anonymousAvatar =
  'https://mindverseglobal.mindverse.com/front-img/crm/1770466922461/Anonymous.png';

function UserMessage({ content, avatar, displayName }: IProps) {
  if (!content) {
    return null;
  }

  return (
    <div className={styles.messageRowLeft}>
      <div className={styles.avatarSimple}>
        <img
          alt={displayName || 'user'}
          className={styles.avatar}
          src={avatar || anonymousAvatar}
        />
      </div>
      <div className={styles.messageContentLeft}>
        <div className={styles.messageBubbleUser}>
          <pre className={styles.messageText}>{content}</pre>
        </div>
      </div>
    </div>
  );
}

export default memo(UserMessage);
